import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "player__info" }
const _hoisted_2 = { class: "breadcrumbs overflow-container" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Players ")
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "breadcrumbs__slash" }, " / ", -1)
const _hoisted_5 = { class: "breadcrumbs__item" }
const _hoisted_6 = { class: "player__created-date" }
const _hoisted_7 = { class: "dashboard__section" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h3", { class: "dashboard__section-title" }, " Discord Accounts ", -1)
const _hoisted_9 = { class: "overflow-container" }
const _hoisted_10 = { class: "table" }
const _hoisted_11 = { class: "players__avatar-header table__cell--centered text--large" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("th", { class: "player__username-header" }, " Username ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("th", { class: "player__id-header" }, " Discord ID ", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("th", null, "Guild Member", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("th", null, "Guild Booster", -1)
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "players__avatar-cell table__cell--centered" }
const _hoisted_18 = {
  key: 0,
  class: "loading-avatar"
}
const _hoisted_19 = ["src", "onError"]
const _hoisted_20 = { class: "player__username" }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("tr", { class: "players__no-players" }, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "5" }, "No Discord accounts found.")
], -1)
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { class: "dashboard__section" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h3", { class: "dashboard__section-title" }, " Steam Accounts ", -1)
const _hoisted_26 = { class: "overflow-container" }
const _hoisted_27 = { class: "table" }
const _hoisted_28 = { class: "players__avatar-header table__cell--centered text--large" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("th", { class: "player__username-header" }, " Username ", -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("th", { class: "player__id-header" }, " Steam ID ", -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("th", null, " Steam Group Member ", -1)
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { class: "players__avatar-cell table__cell--centered" }
const _hoisted_34 = {
  key: 0,
  class: "loading-avatar"
}
const _hoisted_35 = ["src", "onError"]
const _hoisted_36 = { class: "player__username" }
const _hoisted_37 = { key: 1 }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("tr", { class: "players__no-players" }, [
  /*#__PURE__*/_createElementVNode("td", { colspan: "4" }, "No Steam accounts found.")
], -1)
const _hoisted_39 = [
  _hoisted_38
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_external_anchor = _resolveComponent("external-anchor")!
  const _component_copy_button = _resolveComponent("copy-button")!
  const _component_check_or_times = _resolveComponent("check-or-times")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_router_link, {
          class: "breadcrumbs__item",
          to: `/dashboard/${_ctx.$route.params.subdomain}/players`
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["to"]),
        _hoisted_4,
        _createElementVNode("span", _hoisted_5, " Player #" + _toDisplayString(_ctx.player?.playerId), 1)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_6, [
        _createVNode(_component_fa_icon, { icon: ['far', 'clock'] }),
        _createTextVNode(" Created " + _toDisplayString(_ctx.formattedDate), 1)
      ], 512), [
        [_vShow, !_ctx.loading]
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("table", _hoisted_10, [
          _createElementVNode("thead", null, [
            _createElementVNode("th", _hoisted_11, [
              _createVNode(_component_fa_icon, { icon: ['far', 'user-alien'] })
            ]),
            _hoisted_12,
            _hoisted_13,
            _hoisted_14,
            _hoisted_15
          ]),
          (_ctx.player?.discordAccounts.length)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_16, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.player.discordAccounts, (account) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: account.discordId
                  }, [
                    _createElementVNode("td", _hoisted_17, [
                      (account.avatarErrored)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, " ? "))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            class: "players__avatar",
                            src: account.avatar,
                            onError: ($event: any) => (account.avatarErrored = true)
                          }, null, 40, _hoisted_19))
                    ]),
                    _createElementVNode("td", _hoisted_20, _toDisplayString(account.username), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_external_anchor, {
                        class: "anchor--primary",
                        href: `https://discordapp.com/users/${account.discordId}`,
                        "show-icon": false
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(account.discordId), 1)
                        ]),
                        _: 2
                      }, 1032, ["href"]),
                      _createVNode(_component_copy_button, {
                        content: account.discordId
                      }, null, 8, ["content"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_check_or_times, {
                        class: "text--large",
                        success: account.isGuildMember
                      }, null, 8, ["success"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_check_or_times, {
                        class: "text--large",
                        success: account.isGuildBooster
                      }, null, 8, ["success"])
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_21, _hoisted_23))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_24, [
      _hoisted_25,
      _createElementVNode("div", _hoisted_26, [
        _createElementVNode("table", _hoisted_27, [
          _createElementVNode("thead", null, [
            _createElementVNode("th", _hoisted_28, [
              _createVNode(_component_fa_icon, { icon: ['far', 'user-alien'] })
            ]),
            _hoisted_29,
            _hoisted_30,
            _hoisted_31
          ]),
          (_ctx.player?.steamAccounts.length)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_32, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.player.steamAccounts, (account) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: account.steamId
                  }, [
                    _createElementVNode("td", _hoisted_33, [
                      (account.avatarErrored)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_34, " ? "))
                        : (_openBlock(), _createElementBlock("img", {
                            key: 1,
                            class: "players__avatar",
                            src: account.avatar,
                            onError: ($event: any) => (account.avatarErrored = true)
                          }, null, 40, _hoisted_35))
                    ]),
                    _createElementVNode("td", _hoisted_36, _toDisplayString(account.username), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_external_anchor, {
                        class: "anchor--primary",
                        href: `https://steamcommunity.com/profiles/${account.steamId}`,
                        "show-icon": false
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(account.steamId), 1)
                        ]),
                        _: 2
                      }, 1032, ["href"]),
                      _createVNode(_component_copy_button, {
                        content: account.steamId
                      }, null, 8, ["content"])
                    ]),
                    _createElementVNode("td", null, [
                      _createVNode(_component_check_or_times, {
                        class: "text--large",
                        success: account.isSteamGroupMember
                      }, null, 8, ["success"])
                    ])
                  ]))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_37, _hoisted_39))
        ])
      ])
    ])
  ]))
}